import { render, staticRenderFns } from "./GlobalChatBot.vue?vue&type=template&id=b1a01674"
import script from "./GlobalChatBot.vue?vue&type=script&lang=js"
export * from "./GlobalChatBot.vue?vue&type=script&lang=js"
import style0 from "./GlobalChatBot.vue?vue&type=style&index=0&id=b1a01674&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports